import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// Author data
export const features = [
  {
    title: "Homer",
    description: "c. 8th century BCE (Greek) – Ancient Epic Poetry",
    imgSrc: "../media/nib.jpg",
    alt: "Books organized by language in a minimalist interface.",
  },
  {
    title: "Dante Alighieri",
    description: "c. 1265–1321 (Italian) – Medieval Literature",
    imgSrc: "../media/shelf.jpg",
    alt: "Curated bookshelf with short literary summaries.",
  },
  {
    title: "Miguel de Cervantes",
    description: "c. 1547–1616 (Spanish) – Renaissance Literature",
    imgSrc: "../media/to-read.jpg",
    alt: "Minimal reading list showcasing global literature.",
  },
  {
    title: "Rabindranath Tagore",
    description: "c. 1861–1941 (Bengali) – Modernist Literature",
    imgSrc: "../media/typewriter.jpg",
    alt: "Minimal workspace focused on reading and writing.",
  },
  {
    title: "Fyodor Dostoevsky",
    description: "c. 1821–1881 (Russian) – Realist Literature",
    imgSrc: "../media/author.jpg",
    alt: "Author notes and contextual literary insights.",
  },
  {
    title: "Gabriel García Márquez",
    description: "c. 1928–2014 (Colombian) – Magical Realism",
    imgSrc: "../media/reading.jpg",
    alt: "Reader exploring books across cultures.",
  },
  {
    title: "Chinua Achebe",
    description: "c. 1930–2013 (Nigerian) – Postcolonial Literature",
    imgSrc: "../media/nib.jpg",
    alt: "Books organized by language in a minimalist interface.",
  },
  {
    title: "Haruki Murakami",
    description: "c. 1949–present (Japanese) – Contemporary Fiction",
    imgSrc: "../media/shelf.jpg",
    alt: "Curated bookshelf with short literary summaries.",
  },
  {
    title: "Virginia Woolf",
    description: "c. 1882–1941 (British) – Modernist Literature",
    imgSrc: "../media/to-read.jpg",
    alt: "Minimal reading list showcasing global literature.",
  },
  {
    title: "Albert Camus",
    description: "c. 1913–1960 (French) – Existentialist Literature",
    imgSrc: "../media/typewriter.jpg",
    alt: "Minimal workspace focused on reading and writing.",
  },
  {
    title: "Orhan Pamuk",
    description: "c. 1952–present (Turkish) – Contemporary Fiction",
    imgSrc: "../media/author.jpg",
    alt: "Author notes and contextual literary insights.",
  },
  {
    title: "Toni Morrison",
    description: "c. 1931–present (American) – Postcolonial Literature",
    imgSrc: "../media/reading.jpg",
    alt: "Reader exploring books across cultures.",
  },
];

// Helper: generate slug from author name
const generateSlug = (name) => name.toLowerCase().replace(/\s+/g, "-");

export const Authors = () => {
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
    });
  }, []);

  return (
    <section id="authors" style={{ padding: "5rem 0", backgroundColor: "#fff" }}>
      <div className="container text-center">

        {/* Tag */}
        <div
          data-aos="fade-up"
          style={{
            display: "inline-block",
            marginBottom: "1rem",
            padding: "0.4rem 1rem",
            borderRadius: "999px",
            border: "1px solid #ddd",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            fontWeight: 600,
          }}
        >
          Authors
        </div>

        {/* Heading */}
        <h2
          data-aos="fade-up"
          data-aos-delay="100"
          style={{
            maxWidth: "700px",
            margin: "0 auto 1rem",
            fontWeight: 700,
          }}
        >
          Voices That Shaped World Literature
        </h2>

        {/* Subtitle */}
        <p
          data-aos="fade-up"
          data-aos-delay="200"
          style={{
            maxWidth: "700px",
            margin: "0 auto 3rem",
            color: "#6c757d",
          }}
        >
          A focused exploration of writers whose works continue to define
          cultures, movements, and literary traditions.
        </p>

        {/* Cards */}
        <div className="row g-4">
          {features.map((feature, idx) => {
            const isHovered = hovered === idx;
            const slug = generateSlug(feature.title);

            return (
              <div
                key={idx}
                className="col-12 col-md-6 col-lg-3 d-flex"
                data-aos="zoom-in"
                data-aos-delay={idx * 100}
              >
                <a
                  href={`/author/${slug}`}
                  style={{
                    width: "100%",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                  aria-label={feature.title}
                >
                  <div
                    onMouseEnter={() => setHovered(idx)}
                    onMouseLeave={() => setHovered(null)}
                    style={{
                      height: "100%",
                      padding: "1rem",
                      borderRadius: "1rem",
                      backgroundColor: "#fff",
                      boxShadow: isHovered
                        ? "0 14px 35px rgba(0,0,0,0.12)"
                        : "0 4px 12px rgba(0,0,0,0.08)",
                      transform: isHovered
                        ? "translateY(-6px)"
                        : "translateY(0)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={feature.imgSrc}
                      alt={feature.alt}
                      style={{
                        width: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />

                    <h5
                      style={{
                        marginBottom: "0.25rem",
                        fontWeight: 600,
                        color: isHovered ? "#000" : "#212529",
                        transition: "color 0.3s ease",
                      }}
                    >
                      {feature.title}
                    </h5>

                    <p
                      style={{
                        margin: 0,
                        fontSize: "0.9rem",
                        color: "#6c757d",
                      }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
